import { RequestService } from './RequestService';
import config from '@/config/env';

const rService = new RequestService(config.baseUrl, config.recaptchaKey);

export default rService;
